<template>
    <el-row class="signin" type="flex" justify="center" align="middle" style="height: 100vh">
        <el-col :span="24" class="sign-in-form">
            <el-col class="logo">
                <img :src="require('@/assets/images/logo-2.png')" width="75px">
                <h2>INVOICE AUDIT</h2>
            </el-col>

            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                <el-form-item prop="userName" size="medium">
                    <el-input prefix-icon="el-icon-user-solid" v-model="ruleForm.userName" placeholder="Username" @keyup.enter.native="signin('ruleForm')"></el-input>
                </el-form-item>
                <el-form-item prop="password" size="medium">
                    <el-input prefix-icon="el-icon-lock" type="password" v-model="ruleForm.password" placeholder="Password" show-password @keyup.enter.native="signin('ruleForm')"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-col :span="24">
                        <el-button size="medium" type="primary" style="width: 100%" :loading="loading" :disabled="loading" @click="signin('ruleForm')">
                            {{ !loading ? 'Sign-in' : 'Signing-in...' }}
                        </el-button>

                        <p class="forgot-password">Forgot Password? <router-link to="/forgot-password">Click here</router-link></p>
                    </el-col>
                </el-form-item>
            </el-form>
        </el-col>
    </el-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import * as types from '../../store/types';
export default {
    data: () => ({
        ruleForm: {
          userName: '',
          password: ''
        },
        rules: {
          userName: [
            { required: true, message: 'Please input username.', trigger: 'blur' },
          ],
          password: [
            { required: true, message: 'Please input password', trigger: 'blur' }
          ]
        }
    }),
    computed: {
        ...mapGetters({
            loading: `auth/loading`
        })
    },
    methods: {
        ...mapActions({
            signIn: `auth/${types.SIGN_IN}`
        }),
        signin(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.signIn(this.ruleForm);
                }
            })
        }
    }
}
</script>

<style scoped>
.signin{
    background-color: #eeeeee;
}
.sign-in-form{
    border-radius: 5px;
    color: #fff;
    background-color:#2D3744;
    height: 420px;
    width: 300px;
    padding: 45px 30px;
    border: 0.5px solid #fafafa;
}
.logo{
    text-align: center;
    margin-bottom: 30px;
}
.forgot-password{
    text-align: center;
    font-size: 12px;
}
.forgot-password > a, .forgot-password > a:visited{
    text-decoration: none;
    columns: inherit;
}
</style>